import React, { useState } from 'react'
import Modal from 'components/Modal'
import Form from './Form'
import { Link } from 'react-router-dom';

const Consultation = React.memo(() => {
  const [isModalOpen, setModalOpen] = useState(false)
  // const [formValues, setFormValues] = useState({})
  return (
    <>
      <section className="online-consultation-wrapper wow fadeInUp">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 offset-lg-8">
              <div className="online-consultation-main">
                <div className="boxed-border" />
                <div className="online-consultation-area">
                  <p>Keep calm and never lose hope</p>
                  <h6>
                    <Link to="/consultation">
                    <button
                      type="button"
                      className="online-consultation-btn"
                      >
                      Book an Appointment
                    </button>
                    </Link>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
});
// const Consultation = React.memo(() => {
//   const [isModalOpen, setModalOpen] = useState(false)
//   // const [formValues, setFormValues] = useState({})
//   return (
//     <>
//       <section className="online-consultation-wrapper wow fadeInUp">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-4 offset-lg-8">
//               <div className="online-consultation-main">
//                 <div className="boxed-border" />
//                 <div className="online-consultation-area">
//                   <p>Keep calm and never lose hope</p>
//                   <h6>
//                     <button
//                       onClick={() => setModalOpen(true)}
//                       type="button"
//                       className="online-consultation-btn"
//                     >
//                       Book an Appointment
//                     </button>
//                   </h6>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <Modal
//         isShow={isModalOpen}
//         handleModalClose={() => {
//           setModalOpen(false)
//         }}
//         id="book-appointment"
//       >
//         <Modal.Body>
//           <Form
//             isShow={isModalOpen}
//             onCloseForm={() => {
//               setModalOpen(false)
//             }}
//           />
//         </Modal.Body>
//       </Modal>
//     </>
//   )
// });

export default Consultation
